import React, { Component } from "react";
import { AiIcon } from "../AiIcon";
import { $, _ } from "../../../vendor";
import styled from "styled-components";
import { CanvasEventType } from "../../../../common/constants";
import AiGenerationService from "../../../core/services/aiGeneration";
import { themeColors } from "../../../react/sharedStyles";
import { Button } from "../../../Components/Button";
import { FlexSpacer } from "../../../react/components/Gap";
import { BeautifulDialog } from "../../../react/components/Dialogs/BaseDialog";
import { AiSlideContentEditor } from "../GeneratePresentation/Components/AiSlideContentEditor";
import { WithLabel } from "../../../Components/WithLabel";
import { FlexBox } from "../../../react/components/LayoutGrid";
import { HorizontalPropertyList, PropertyPanelContainer, PropertySection } from "../../../EditorComponents/PropertyPanel";
import { ToggleSwitch } from "../../../Components/ToggleSwitch";
import GeneratePresentationController from "../GeneratePresentation/GeneratePresentationController";
import { Dropdown } from "../../../Components/Dropdown";
import { MenuItem } from "../../../Components/Menu";
import { Icon } from "../../../Components/Icon";
import { Key } from "../../../core/utilities/keys";
import SlideAiController from "./SlideAiController";
import { AiImageSourcePopup, AiImageStylePopup } from "../GenerateImage/AiImageStyle";
import { DialogActions, DialogTitle } from "@material-ui/core";

const SLIDE_GAP = 20;

const Container = styled.div`
    width: 100%;
    //height: 400px;
    display: grid;
    grid-template-areas: 
"prompt options";
    //grid-template-rows: 50px 1fr;
    grid-template-columns: 1fr 300px;
    row-gap: 10px;
    background: #f9f9f9;
`;

const Header = styled.div`
    grid-area: header;
    background: white;
    color: #333;
    font-weight: bold;
    font-size: 18px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
`;

const PromptContainer = styled.div`
    grid-area: prompt;
    padding: 15px 20px;
`;

const OptionsContainer = styled.div`
    grid-area: options;
    padding: 15px 20px 0px 0px;
    height: 400px;
`;

const TextContainer = styled.div`
    background: #fff;
    border: solid 1px #ccc;
    padding: 10px;
    width: 100%;
    min-height: 100px;
    height: 400px;
    pointer-events: auto;
    overflow-y: auto;
`;

class SlideAiDialog extends Component {
    constructor(props) {
        super(props);

        let metadata = props.currentSlide.getMetadata() ?? {
            title: "Loading..."
        };

        let prompt;

        if (metadata.slidePrompt) {
            prompt = metadata.slidePrompt;

            if (typeof prompt === "object") {
                prompt = JSON.stringify(prompt, null, 2);
            }
        } else {
            prompt = props.currentSlide.getSlideText().trim();
        }
        // prompt = marked.parse(prompt);

        // prompt = markdownToTxt(prompt, { gfm: true, breaks: true});
        // prompt = markdownToTxt(prompt);

        this.state = {
            currentModel: _.cloneDeep(props.currentSlide.attributes),
            isGenerating: false,
            selectedModel: null,
            textDensity: 1,
            slideCategory: null,
            originalSlidePrompt: metadata.originalSlidePrompt,
            slidePrompt: prompt,
            slideType: "auto",
            preserveExactText: !!metadata.preserveExactText,
            usePresentationAsContext: true,
            regenImage: false,
            files: metadata.files ? metadata.files.map(f => f.hasBeenUsedFor === "slide" ? ({ ...f, hasBeenUsed: false }) : f) : [],
            isDragging: false,
            isSavingFiles: false,
            slideWidth: (window.innerWidth - SLIDE_GAP * 4 - 64) / 3 - 10,
            ideas: metadata.generatedSlides || [],
            imageSource: "ai",
            imageStyle: metadata.generatedModel?.slideImage?.imageStyle
        };

        // this.hasBeenUnmounted = false;

        this.promptRef = React.createRef();
    }

    componentDidMount() {
        const { currentSlide, currentCanvasController } = this.props;

        // if (SlideAiController.currentSlide !== currentSlide) {
        //     SlideAiController.setCurrentSlide(currentSlide, currentCanvasController);
        // }

        $(window).on("keydown", event => {
            if (event.which == Key.ESCAPE) {
                this.props.closeDialog();
            }
        });
    }

    regenerateSlide = async () => {
        const { currentSlide, closeDialog } = this.props;
        const { slideType, preserveExactText, usePresentationAsContext, files, regenImage, imageSource, imageStyle } = this.state;

        this.setState({ isGenerating: true });
        let slidePrompt = this.promptRef.current.getMarkdown();

        closeDialog();

        let slideImageResponse;
        if (regenImage) {
            slideImageResponse = await AiGenerationService.generateSlideImagePrompt(
                slidePrompt,
                currentSlide.presentation.get("metadata").topic
            );
        }

        await SlideAiController.regenerateIdeas(slidePrompt, {
            slideType,
            preserveExactText,
            usePresentationAsContext,
            files
        });

        if (regenImage && slideImageResponse) {
            SlideAiController.regenerateSlideImage(slideImageResponse.slideImagePrompt, imageStyle);
        }
        this.setState({ isGenerating: false });
    }

    handleApplySlide = model => {
        const { currentSlide, currentCanvasController, closePopup } = this.props;

        currentCanvasController.canvas.once(CanvasEventType.REFRESH, () => {
            this.props.closeDialog();
            // window.requestAnimationFrame(() => {
            //     PresentationEditorController.playAnimation();
            // });
        });

        currentSlide.update({
            ...currentSlide.attributes,
            animations: {},
            states: model.states,
            layout: model.layout,
            template_id: model.template_id,
            version: 10,
            migrationVersion: 10.03,
            metadata: {
                ...model.metadata,
                needsLayoutProcessing: true,
                aiVariationApproved: true,
            }
        }, { removeMissingKeys: true });
    }

    render() {
        const { theme } = this.props;
        let { isGenerating, slidePrompt, imageSource, imageStyle, preserveExactText, usePresentationAsContext, slideType, regenImage, language } = this.state;

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog} maxWidth="lg">
                <DialogTitle>
                    <FlexBox left middle>
                        {/*<AiIcon contained size={20} />  */}
                        Generate Slide Ideas with AI
                    </FlexBox>
                </DialogTitle>
                <Container>
                    <PromptContainer>
                        <WithLabel label="Slide Prompt" above left fillHeight gap={15}>
                            <TextContainer>
                                <AiSlideContentEditor ref={this.promptRef} text={slidePrompt} onChange={slidePrompt => this.setState({ slidePrompt })} />
                            </TextContainer>
                            <Button unframed>Add File...</Button>
                        </WithLabel>
                    </PromptContainer>
                    <OptionsContainer>
                        <WithLabel label="Options" above left fillHeight gap={15}>
                            <PropertyPanelContainer style={{ border: "solid 1px #ccc" }}>
                                <PropertySection>
                                    <WithLabel label="Slide Type">
                                        <Dropdown value={slideType} onChange={slideType => this.setState({ slideType })}>
                                            <MenuItem value="auto">Auto</MenuItem>
                                            <MenuItem value="title">Title Slide</MenuItem>
                                            <MenuItem value="table">Table</MenuItem>
                                        </Dropdown>
                                    </WithLabel>
                                </PropertySection>
                                <PropertySection>
                                    <WithLabel left label="Use Presentation Context" toolTip="Generate this slide using the context of the entire presentation.">
                                        <ToggleSwitch value={usePresentationAsContext} onChange={usePresentationAsContext => this.setState({ usePresentationAsContext })} />
                                    </WithLabel>
                                </PropertySection>
                                <PropertySection>
                                    <WithLabel left label="Preserve Exact Text" toolTip="Try to keep the text in the generated slides exactly as it appears in the prompt.">
                                        <ToggleSwitch value={preserveExactText} onChange={preserveExactText => this.setState({ preserveExactText })} />
                                    </WithLabel>
                                </PropertySection>
                                <PropertySection>
                                    <WithLabel left label="Regenerate Image" toolTip="Regenerate the slide image based on the slide prompt.">
                                        <ToggleSwitch value={regenImage} onChange={regenImage => this.setState({ regenImage })} />
                                    </WithLabel>
                                    {regenImage && (
                                        <HorizontalPropertyList>
                                            <AiImageSourcePopup imageSource={imageSource} onChange={imageSource => this.setState({ imageSource })} />
                                            {imageSource == "ai" && (
                                                <WithLabel label="Ai Image Style" above>
                                                    <AiImageStylePopup theme={theme} imageStyle={imageStyle} onChange={imageStyle => this.setState({ imageStyle })} />
                                                </WithLabel>
                                            )}
                                        </HorizontalPropertyList>
                                    )}
                                </PropertySection>
                            </PropertyPanelContainer>
                        </WithLabel>
                    </OptionsContainer>
                </Container>
                <DialogActions>
                    <FlexSpacer />
                    <Button unframed onClick={this.props.closeDialog}>Cancel</Button>
                    <Button unframed textColor={themeColors.aiColor} onClick={this.regenerateSlide} showSpinner={isGenerating} disabled={isGenerating}>
                        <Icon>
                            <AiIcon iconColor={themeColors.aiColor} />
                        </Icon>
                        Generate Slide Ideas
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export default SlideAiController.withState(SlideAiDialog);

